<template>
    <div class="row">
        <div class="d-flex justify-content-between bg-secondary p-2 mb-2 text-white rounded">

            <h2 class="ff-l1">Liste des clients</h2>
            <button class="btn btn-primary" @click="$router.push({name: 'clients.create'})"><i class="bi bi-person-plus me-1"></i>Ajouter</button>
        </div>
        <div class="row">
            <div class="mb-2 col-md-6 col-12">
                <input type="text" class="form-control" placeholder="Recherche nom ou telephone" v-model="search"/>
            </div>
        </div>

        <div v-if="clients.length > 0" class="row">
            <client-in-list v-for="c in clientsToPrint" :key="c.id" :client="c" class="col-12 col-md-4">

            </client-in-list>
        </div>
        <div v-else>No clients yet.</div>

    </div>
</template>

<script>
import ClientInList from '@/components/elements/ClientInList.vue'

export default {
    name: 'ClientsList',
    components: { ClientInList },
    data() {
        return {
            clients: [],
            search:""
        }
    },
    computed:{
        clientsToPrint(){
            let s = this.search.toLowerCase();
            return this.search.length >= 3 ? this.clients.filter((ele)=>{
                return ele.nom?.toLowerCase().includes(s) 
                    || ele.prenoms?.toLowerCase().includes(s) 
                    || ele.telephone?.toLowerCase().includes(s)
                    || ele.telephone2?.toLowerCase().includes(s)
            }):
            this.clients
        }
    },
    methods: {
        getClients() {
            this.$api.get('/clients')
                .then(response => {
                    this.clients = response.data.data;
                })
                .catch(error => {
                    console.error('There was an error fetching the clients!', error);
                });
        }
    },
    created() {
        this.getClients();
    }
}
</script>

<style scoped>
table {
    width: 100%;
    margin-top: 8px
}
</style>
